import React, { useMemo } from "react";
import { columnRenderArrayData } from "utils/tableUtils";

import GenericPullConfigListing from "../GenericPullConfigListing";
import AcunetixPremiumCredentialsForm from "./AcunetixPremiumCredentialsForm";
import AcunetixPremiumMappingForm from "./AcunetixPremiumMappingForm";

interface AcunetixPremiumConfigListingProps {
  name: string;
  loginConfigList: any;
  extraLoginConfigFields: any;
  triggerModifyParam: any;
  [key: string]: any;
}
const AcunetixPremiumConfigListing: React.FC<
  AcunetixPremiumConfigListingProps
> = (props) => {
  const columns = useMemo(
    () => [
      {
        title: "Target Group",
        dataIndex: "targetGroupName",
        width: 240,
      },
      {
        title: "Targets",
        dataIndex: "targetName",
        width: 240,
        render: columnRenderArrayData,
      },
    ],
    [],
  );
  return (
    <GenericPullConfigListing
      {...props}
      toolName={props.name}
      MappingForm={AcunetixPremiumMappingForm}
      CredentialsForm={AcunetixPremiumCredentialsForm}
      extraColumns={columns}
    />
  );
};

export default AcunetixPremiumConfigListing;
